import React from "react";
import { VisionStudioSpinner } from "../../components";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const withSpinner = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const WithSpinner: React.FC<P> = (props) => {
    const { isSpinnerLoading, spinnerText } = useSelector(
      (state: RootState) => state.UIReducer
    );

    return (
      <Box sx={{ position: "relative", height: "100%" }}>
        {isSpinnerLoading && (
          <Box
            sx={{
              position: "fixed",
              top: "100px",
              left: "75px",
              width: "100%",
              height: "90vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.48)",
              zIndex: 9999,
            }}
          >
            <Typography
              sx={{
                position: "fixed",
                top: "50%", // Center vertically
                left: "50%", // Center horizontally
                transform:
                  "translate(-50%, -50%) translateX(+30px) translateY(+100px)", // Center and adjust by 20px to the left
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                color: "#333",
                textAlign: "center",
              }}
            >
              {spinnerText}
            </Typography>

            <VisionStudioSpinner />
          </Box>
        )}
        <WrappedComponent {...props} />
      </Box>
    );
  };

  return WithSpinner;
};

export default withSpinner;
